// extracted by css-extract-rspack-plugin
export default {"link":"_f5bce70f","img":"_e6d5f9ec","text":"_1d9d7392"};